'use client';

import { useDialogStore } from '@/app/lib/stores/dialog.store';
import CommandIcon from '@/app/ui/assets/icons/command-icon';
import DiscordJoinButton from '@/app/ui/components/molecules/discord-join-button';
import GithubButton from '@/app/ui/components/molecules/github-button';
import useKeyboardShortcut from '@/app/ui/hooks/use-keyboard-shortcut';
import dynamic from 'next/dynamic';
import { Button } from '@/app/ui/components/atoms/button';
import SearchDialogContent from '@/app/ui/layouts/docs/components/search-dialog';
import TwitterFollowButton from '@/app/ui/components/molecules/twitter-follow-button';
import React, { useCallback } from 'react';
import SearchIcon from '../../../assets/icons/search-icon';

const HeaderDesktopSearchButtonIcon = dynamic(async () => await import('@/app/ui/layouts/docs/components/header-desktop-search-button-icon'), {
  ssr: false,
  loading: () => (
    <div className='ml-10 flex items-center justify-start gap-0.5 rounded border border-slate-200 bg-white p-1 px-1.5 py-0.5'>
      <CommandIcon className='size-4 stroke-slate-400 group-hover:stroke-white' />
      <span className='text-slate-400 group-hover:text-white'>K</span>
    </div>
  ),
});

export default function HeaderDesktop() {
  const { setDialogContent, setIsDialogVisible } = useDialogStore();

  const handleShowSearch = useCallback(() => {
    setIsDialogVisible(true);
    setDialogContent(<SearchDialogContent />);
  }, [setDialogContent, setIsDialogVisible]);

  useKeyboardShortcut(handleShowSearch, { code: 'KeyK', ctrlKey: true, desktopOnly: true });
  useKeyboardShortcut(handleShowSearch, { code: 'KeyK', metaKey: true, desktopOnly: true });

  return (
    <header className='hidden h-full border-b border-gray-200 p-3 px-6 xl:block'>
      <div className='size-full max-w-[calc(1536px-3rem)] items-center justify-between xl:flex'>
        <div>
          <Button
            id='search'
            variant='outlined'
            startAdornment={<SearchIcon className='size-5 stroke-black group-hover:stroke-white' />}
            endAdornment={<HeaderDesktopSearchButtonIcon />}
            className='border-slate-300 px-3 font-medium text-slate-400 hover:border-black hover:bg-black'
            onClick={handleShowSearch}
          >
            Search components
          </Button>
        </div>
        <nav className='hidden gap-6 md:flex'>
          <DiscordJoinButton className='text-blue-700' iconClassName='stroke-blue-700' />
          <GithubButton className='text-black' iconClassName='stroke-black' />
          {/* temporarily hidden */}
          {/* <FigmaButton className='text-black' iconClassName='stroke-black' /> */}
          <TwitterFollowButton />
        </nav>
      </div>
    </header>
  );
}
